import { SET_EDITOR_SELECTED_NODE } from 'client/constants/actions';
import { SELECTION_TYPES } from 'client/components/common/SelectionHint/utils';
import { SelectionSingleType } from 'client/components/common/SelectionHint/types';

export type SetEditorSelectedNodePayload = {
	type: ValuesType<typeof SELECTION_TYPES>;
	data?: Array<SelectionSingleType> | SelectionSingleType;
	isMultiSelect?: boolean; // is selected multiple blocks
};

export function setEditorSelectedNode(payload: SetEditorSelectedNodePayload) {
	return async (dispatch, getState) => {
		await dispatch({ type: SET_EDITOR_SELECTED_NODE, payload });
		return getState().editor.selection;
	};
}
